import {
  createSharedComposable,
  useDocumentVisibility,
  useNow,
} from '@vueuse/core';

export const useClock = createSharedComposable(() => {
  const now = useNow({ interval: 1000, controls: true });
  const visibility = useDocumentVisibility();

  watch(visibility, (v) => (v === 'hidden' ? now.pause() : now.resume()), {
    immediate: true,
  });

  return now;
});
